// import { useParams, Link } from 'react-router-dom'
import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import TimetableTable from '../../usables/TimetableTable'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Modal from '../../usables/Modal'
import Select from 'react-select'

export default function  Timetable() {
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [timetableEntries, setTimetableEntries] = useState([])
  const [formData2, setFormData2] = useState({value: '', teacher_id: '', teacher_name: '', leson:'', day: ''})
  const [teachersList, setTeachersList] = useState([])
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)
  const [classes, setClasses] = useState([])

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const createEntry = (formData) => {
    if(timetableEntries.some(e => e[formData.teacher_name]?.[formData.day]?.[formData.leson] !== undefined))
      if(!window.confirm('Ar tikrai norite perrašyti dabartinę reikšmę?')) {
        setFormData2({value: '', teacher_id: '', teacher_name: '', leson:'', day: ''})
        return
      }
    axios.patch(process.env.REACT_APP_API + '/timetable', formData, config)
      .then((res)=>{
        if(res.status === 200){
          window.location.reload()
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/timetable', config)
    .then(res => {
      setTimetableEntries([])
      const object1 = Object.entries(twoD(res.data))
      object1.sort()
      object1.forEach(entry => {
        const temp = []
        temp.push(entry)
        setTimetableEntries(entries => [...entries, Object.fromEntries(temp)])
      })
      setDataLoaded({done: true, sucssess: true, items: res.data.length})
    })
    .catch(err => {
      setTimetableEntries(entries => [...entries, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })

    axios.get(process.env.REACT_APP_API + '/teacher', config)
      .then(res => {
        if(res.status === 200){
          setTeachersList([]) //! Pašalinti prieš buildinant
          res.data.forEach((data) => {
            setTeachersList(teachers => [...teachers, data])
          })
        }
      })
      .catch(err => {
        setTeachersList([]) //! Pašalinti prieš buildinant
        setTeachersList(teachers => [...teachers, err.response.data])
        // setDataLoaded({done: true, sucssess: false, items: 0})
      })

      axios.get(process.env.REACT_APP_API + '/class', config)
      .then(res => {
        if(res.status === 200){
          //console.log(...res.data)
          setClasses([]) //! Pašalinti prieš buildinant
          res.data.forEach((data) => {
            setClasses(classes => [...classes, data])
          })
        }
      })
      .catch(err => {
        setClasses([]) //! Pašalinti prieš buildinant
        setClasses(classes => [...classes, err.response.data])
        // setDataLoaded({done: true, sucssess: false, items: 0})
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
    <h2>Tvarkaraštis</h2>
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <TimetableTable columns={tableColumns} data={timetableEntries} />
          : <ClosingAlert type='warning' message='Tvarkaraštis nerastas' />
        : <ClosingAlert type='error' message='Kažkas nepavyko, bendykite vėl šiek tiek vėliau' />
      }
    
    {authUser().roles.admin &&
      <Modal showAddBtn={true} title='Redaguoti' saveText='Išsaugoti' btnDisabled={formData2.teacher_id === '' || formData2.leson === '' || formData2.day === '' || formData2.value === '' ? true : false} submitFunction={() => createEntry(formData2)}>
        <div className='pt-0'>
          <label className='text-gray-500' htmlFor="class">Mokytojas</label>
          <Select 
          name='lesson'
          defaultValue={(formData2.teacher_id !== '') ? {value: formData2.teacher_id, label: formData2.teacher_name} : null} 
          onChange={(e)=>setFormData2({...formData2, teacher_id: e.value, teacher_name: e.label})} 
          options={
            teachersList.map(teacher => {
              return ((teacher !== 'undefined' && teacher.person !== null) ? { value: teacher.id, label: teacher.person.name + ' ' + teacher.person.lastname } : null)
            })
          } />
        </div>
        <div className='pt-3'>
          <label className='text-gray-500' htmlFor="class">Pamoka</label>
          <Select 
          name='lesson'
          defaultValue={(formData2.leson !== '') ? {value: formData2.leson, label: formData2.leson + '-a pamoka'} : null} 
          onChange={(e)=>setFormData2({...formData2, leson: e.value})} 
          options={
            [1, 2, 3, 4, 5, 6, 7, 8].map(lesson => {
              return ({ value: lesson, label: lesson + '-a pamoka' })
            })
          } />
        </div>
        <div className='pt-3'>
          <label className='text-gray-500' htmlFor="class">Diena</label>
          <Select 
          name='day'
          defaultValue={(formData2.day !== '') ? {value: formData2.day, label: formData2.day} : null} 
          onChange={(e)=>setFormData2({...formData2, day: e.value})} 
          options={
            ['Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis'].map(day => {
              return ({ value: day, label: day })
            })
          } />
        </div>
        <div className='pt-3'>
          <label className='text-gray-500' htmlFor="class">Klasė</label>
          <Select 
          name='class'
          defaultValue={(formData2.value !== '') ? {value: formData2.value, label: formData2.value} : null} 
          onChange={(e)=>setFormData2({...formData2, value: e.label})} 
          options={
            classes.map(sclass => {
              return ({ value: sclass.id, label: sclass.name })
            })
          } />
        </div>
      </Modal>
}
    </>
  )
}

function twoD(data) {
  const final = {}
  Object.keys(data).forEach(key => {
    if (typeof final[data[key].teacher.person.name+' '+data[key].teacher.person.lastname] === 'undefined') {
      final[data[key].teacher.person.name+' '+data[key].teacher.person.lastname] = {id: data[key].teacher_id}
    }
    if (typeof final[data[key].teacher.person.name+' '+data[key].teacher.person.lastname][data[key].weekday.day] === 'undefined') {
      final[data[key].teacher.person.name+' '+data[key].teacher.person.lastname][data[key].weekday.day] = {}
    }
    if (typeof final[data[key].teacher.person.name+' '+data[key].teacher.person.lastname][data[key].weekday.day][data[key].lesson] === 'undefined') {
      Object.assign(final[data[key].teacher.person.name+' '+data[key].teacher.person.lastname][data[key].weekday.day], {[data[key].lesson] : data[key].class.name})
    }
  //final[data[key].teacher.person.name+' '+data[key].teacher.person.lastname][data[key].weekday.day][data[key].lesson] = data[key].class.name
  })
	return final
}

const tableColumns = [
  {
    Header: 'xMokytojas',
    columns: [
      {
        Header: 'xVardas',
        accessor: (row) => {
          return Object.keys(row)[0]
        },//Object.keys()[0]
      },
    ],
  },
  {
    Header: 'xPirmadienis',
    columns: [
      {
        Header: 'x1',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Pirmadienis;
          if (entry !== undefined){
            return entry[1]
          }
          return ''
        },
      },
      {
        Header: 'x2',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Pirmadienis;
          if (entry !== undefined){
            return entry[2]
          }
          return ''
        },
      },
      {
        Header: 'x3',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Pirmadienis;
          if (entry !== undefined){
            return entry[3]
          }
          return ''
        },
      },
      {
        Header: 'x4',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Pirmadienis;
          if (entry !== undefined){
            return entry[4]
          }
          return ''
        },
      },
      {
        Header: 'x5',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Pirmadienis;
          if (entry !== undefined){
            return entry[5]
          }
          return ''
        },
      },
      {
        Header: 'x6',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Pirmadienis;
          if (entry !== undefined){
            return entry[6]
          }
          return ''
        },
      },
      {
        Header: 'x7',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Pirmadienis;
          if (entry !== undefined){
            return entry[7]
          }
          return ''
        },
      },
      {
        Header: 'x8',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Pirmadienis;
          if (entry !== undefined){
            return entry[8]
          }
          return ''
        },
      },
    ],
  },
  {
    Header: 'xAntradienis',
    columns: [
      {
        Header: 'a1',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Antradienis;
          if (entry !== undefined){
            return entry[1]
          }
          return ''
        },
      },
      {
        Header: 'a2',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Antradienis;
          if (entry !== undefined){
            return entry[2]
          }
          return ''
        },
      },
      {
        Header: 'a3',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Antradienis;
          if (entry !== undefined){
            return entry[3]
          }
          return ''
        },
      },
      {
        Header: 'a4',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Antradienis;
          if (entry !== undefined){
            return entry[4]
          }
          return ''
        },
      },
      {
        Header: 'a5',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Antradienis;
          if (entry !== undefined){
            return entry[5]
          }
          return ''
        },
      },
      {
        Header: 'a6',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Antradienis;
          if (entry !== undefined){
            return entry[6]
          }
          return ''
        },
      },
      {
        Header: 'a7',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Antradienis;
          if (entry !== undefined){
            return entry[7]
          }
          return ''
        },
      },
      {
        Header: 'a8',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Antradienis;
          if (entry !== undefined){
            return entry[8]
          }
          return ''
        },
      },
    ],
  },
  {
    Header: 'xTrečiadienis',
    columns: [
      {
        Header: 't1',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Trečiadienis;
          if (entry !== undefined){
            return entry[1]
          }
          return ''
        },
      },
      {
        Header: 't2',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Trečiadienis;
          if (entry !== undefined){
            return entry[2]
          }
          return ''
        },
      },
      {
        Header: 't3',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Trečiadienis;
          if (entry !== undefined){
            return entry[3]
          }
          return ''
        },
      },
      {
        Header: 't4',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Trečiadienis;
          if (entry !== undefined){
            return entry[4]
          }
          return ''
        },
      },
      {
        Header: 't5',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Trečiadienis;
          if (entry !== undefined){
            return entry[5]
          }
          return ''
        },
      },
      {
        Header: 't6',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Trečiadienis;
          if (entry !== undefined){
            return entry[6]
          }
          return ''
        },
      },
      {
        Header: 't7',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Trečiadienis;
          if (entry !== undefined){
            return entry[7]
          }
          return ''
        },
      },
      {
        Header: 't8',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Trečiadienis;
          if (entry !== undefined){
            return entry[8]
          }
          return ''
        },
      },
    ],
  },
  {
    Header: 'xKetvirtadienis',
    columns: [
      {
        Header: 'k1',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Ketvirtadienis;
          if (entry !== undefined){
            return entry[1]
          }
          return ''
        },
      },
      {
        Header: 'k2',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Ketvirtadienis;
          if (entry !== undefined){
            return entry[2]
          }
          return ''
        },
      },
      {
        Header: 'k3',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Ketvirtadienis;
          if (entry !== undefined){
            return entry[3]
          }
          return ''
        },
      },
      {
        Header: 'k4',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Ketvirtadienis;
          if (entry !== undefined){
            return entry[4]
          }
          return ''
        },
      },
      {
        Header: 'k5',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Ketvirtadienis;
          if (entry !== undefined){
            return entry[5]
          }
          return ''
        },
      },
      {
        Header: 'k6',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Ketvirtadienis;
          if (entry !== undefined){
            return entry[6]
          }
          return ''
        },
      },
      {
        Header: 'k7',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Ketvirtadienis;
          if (entry !== undefined){
            return entry[7]
          }
          return ''
        },
      },
      {
        Header: 'k8',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Ketvirtadienis;
          if (entry !== undefined){
            return entry[8]
          }
          return ''
        },
      },
    ],
  },
  {
    Header: 'xPenktadienis',
    columns: [
      {
        Header: 'p1',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Penktadienis;
          if (entry !== undefined){
            return entry[1]
          }
          return ''
        },
      },
      {
        Header: 'p2',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Penktadienis;
          if (entry !== undefined){
            return entry[2]
          }
          return ''
        },
      },
      {
        Header: 'p3',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Penktadienis;
          if (entry !== undefined){
            return entry[3]
          }
          return ''
        },
      },
      {
        Header: 'p4',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Penktadienis;
          if (entry !== undefined){
            return entry[4]
          }
          return ''
        },
      },
      {
        Header: 'p5',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Penktadienis;
          if (entry !== undefined){
            return entry[5]
          }
          return ''
        },
      },
      {
        Header: 'p6',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Penktadienis;
          if (entry !== undefined){
            return entry[6]
          }
          return ''
        },
      },
      {
        Header: 'p7',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Penktadienis;
          if (entry !== undefined){
            return entry[7]
          }
          return ''
        },
      },
      {
        Header: 'p8',
        accessor: (row) => {
          const entry = row[Object.keys(row)[0]].Penktadienis;
          if (entry !== undefined){
            return entry[8]
          }
          return ''
        },
      },
    ],
  },
]